/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import {
  UPDATE_USER,
  UPDATE_USERS,
  UPDATE_PROFILE_NAME_SUCCESS,
  UPDATE_USER_FULLNAME,
  UPDATE_USER_PREFERRED_LANGUAGE_SUCCESS,
} from './actions';
import { UPDATE_PROFILE } from '../Profiles/actions';
import {
  UPDATE_ENROLLED_CLASS_DATA,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  UPDATE_SIMPLE_ENROLLED_CLASS_DATA,
} from '../Auth/actions';
import {
  SET_BLOCK_FEED_DATA,
  APPEND_BLOCK_FEED_DATA,
  PREPEND_BLOCK_FEED_DATA,
  FEED_DATA_FETCH_SUCCESS,
  FEED_DATA_REFRESH_SUCCESS,
  FEED_DATA_LOAD_MORE_SUCCESS,
} from '../Feeds/actions';
import {
  NOTIFICATION_READ_FETCH_SUCCESS,
  NOTIFICATION_READ_REFRESH_SUCCESS,
  NOTIFICATION_READ_LOAD_MORE_SUCCESS,
  NOTIFICATION_UNREAD_FETCH_SUCCESS,
  NOTIFICATION_UNREAD_REFRESH_SUCCESS,
  NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS,
} from '../Notifications/actions';
import {
  COMMENT_LIST_FETCH_SUCCESS,
  COMMENT_LIST_LOAD_SUCCESS,
} from '../Comments/CommentList/actions';
import { FETCH_NOTIFICATION_DETAIL_SUCCESS } from '../PushNotification/actions';
import { GET_LINKED_NOTIFICATION_DATA } from '../LinkedNotification/actions';
import { ActionTypes as GalleryActionTypes } from '../Galleries/actions';
import {
  SET_COURSE_LANDING_PAGE_DATA,
  FETCH_COURSE_SUBSCRIPTION_DATA_SUCCESS,
  FETCH_ENROLLED_CLASS_DATA_SUCCESS,
} from '../Courses/actions';
import { COURSELANDING_PAGE_SUCCESS } from '../Courses/CourseLanding/actions';
import { BLOCKPAGE_DATA_LOADED_SUCCESS } from '../BlockPageUI/actions';
import { FETCH_STUDENT_CERTIFICATIONS_SUCCESS } from '../Certification/actions';
import {
  WASABI_SEARCH_USERS_SUCCESS,
  WASABI_FETCH_USER_SUCCESS,
  WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_SUCCESS,
  WASABI_CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS,
} from '../Wasabi/users/actions';
import { FETCH_LOGGED_IN_USER_DATA_SUCCESS } from '../LoggedInUser/actions';
import {
  FETCH_COURSE_LANDING_PAGE_DATA_SUCCESS,
  SAVE_COURSE_LANDING_PAGE_SUCCESS,
  ADD_COURSE_LANDING_PAGE_TEAM_MEMBER,
  FETCH_COURSE_ROLES_DATA_SUCCESS,
} from '../CourseAdmin/actions';
import { FETCH_COHORT_GROUP_USERS_SUCCESS } from '../CohortGroups/actions';
import {
  WASABI_SAAS_FETCH_USER_SUBSCRIPTIONS_SUCCESS,
  WASABI_SAAS_FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS,
} from '../Wasabi/saasSubscriptions/actions';
import { FETCH_COHORT_GROUPS_LISTING_DATA_SUCCESS } from '../Groups/actions';

const updateUsers = (state, users) => {
  const immutableUsers = Immutable.fromJS(users);
  let newState = state;
  for (const user of immutableUsers.values()) {
    newState = newState.mergeIn([user.get('userId')], user);
  }
  return newState;
};

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function Users(state = Immutable.Map(), action) {
  switch (action.type) {
    case UPDATE_USER:
    case FETCH_COURSE_SUBSCRIPTION_DATA_SUCCESS:
    case WASABI_FETCH_USER_SUCCESS:
    case WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_SUCCESS:
    case WASABI_CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS:
    case WASABI_SAAS_FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS: {
      const { user } = action;
      return state.mergeIn([user.userId], Immutable.fromJS(user));
    }
    case UPDATE_PROFILE: {
      const { user } = action;
      return state.mergeIn([user.userId], Immutable.fromJS(user));
    }
    case UPDATE_USER_FULLNAME: {
      const { userId, fullName } = action;
      return state.setIn([userId, 'fullName'], fullName);
    }
    case UPDATE_USER_PREFERRED_LANGUAGE_SUCCESS: {
      const { userId, language } = action;

      return state.setIn([userId, 'preferredLanguage'], language);
    }
    case FETCH_LOGGED_IN_USER_DATA_SUCCESS: {
      const { userId, userData } = action;

      delete userData.emailAddress;
      delete userData.timezone;

      return state.mergeIn([userId], Immutable.fromJS(userData));
    }
    case APPEND_BLOCK_FEED_DATA:
    case PREPEND_BLOCK_FEED_DATA:
    case SET_BLOCK_FEED_DATA:
    case UPDATE_USERS:
    case FETCH_COURSE_ROLES_DATA_SUCCESS:
    case GET_LINKED_NOTIFICATION_DATA:
    case GalleryActionTypes.PORTFOLIO_QUERY_COMPLETE:
    case SET_COURSE_LANDING_PAGE_DATA:
    case COURSELANDING_PAGE_SUCCESS:
    case NOTIFICATION_READ_FETCH_SUCCESS:
    case NOTIFICATION_READ_REFRESH_SUCCESS:
    case NOTIFICATION_READ_LOAD_MORE_SUCCESS:
    case NOTIFICATION_UNREAD_FETCH_SUCCESS:
    case NOTIFICATION_UNREAD_REFRESH_SUCCESS:
    case NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS:
    case UPDATE_ENROLLED_CLASS_DATA:
    case FEED_DATA_FETCH_SUCCESS:
    case FEED_DATA_REFRESH_SUCCESS:
    case FEED_DATA_LOAD_MORE_SUCCESS:
    case COMMENT_LIST_FETCH_SUCCESS:
    case COMMENT_LIST_LOAD_SUCCESS:
    case FETCH_NOTIFICATION_DETAIL_SUCCESS:
    case FETCH_COHORT_GROUP_USERS_SUCCESS:
    case GalleryActionTypes.FETCH_GALLERY_POSTS_SUCCESS:
    case GalleryActionTypes.LOAD_MORE_GALLERY_POSTS_SUCCESS:
    case FETCH_COHORT_GROUPS_LISTING_DATA_SUCCESS:
    case FETCH_STUDENT_CERTIFICATIONS_SUCCESS:
    case UPDATE_SIMPLE_ENROLLED_CLASS_DATA: {
      return updateUsers(state, action.users);
    }
    case FETCH_ENROLLED_CLASS_DATA_SUCCESS: {
      const user = Immutable.fromJS(action.user);
      const creator = Immutable.fromJS(action.creator);
      return state
        .mergeIn([user.get('userId')], Immutable.fromJS(user))
        .mergeIn([creator.get('userId')], Immutable.fromJS(creator));
    }
    case LOGIN_SUCCESS: {
      const user = Immutable.fromJS(action.user);
      return state.mergeIn([user.get('userId')], Immutable.fromJS(user));
    }
    case UPDATE_PROFILE_NAME_SUCCESS: {
      const { userId, name } = action;
      return state.setIn([userId, 'fullName'], name);
    }
    case LOGOUT_SUCCESS: {
      return Immutable.Map();
    }
    case BLOCKPAGE_DATA_LOADED_SUCCESS: {
      const { exhibitPosts, groupUsers } = action;
      let newState = state;
      if (exhibitPosts) {
        newState = updateUsers(newState, exhibitPosts.users);
      }
      if (groupUsers) {
        newState = updateUsers(newState, groupUsers);
      }
      return newState;
    }
    case WASABI_SEARCH_USERS_SUCCESS: {
      const { users } = action;
      return updateUsers(state, users);
    }
    case FETCH_COURSE_LANDING_PAGE_DATA_SUCCESS:
    case SAVE_COURSE_LANDING_PAGE_SUCCESS: {
      const {
        landingPageData: { teamMembers },
      } = action;
      return updateUsers(state, teamMembers);
    }
    case ADD_COURSE_LANDING_PAGE_TEAM_MEMBER: {
      const { teamMember } = action;
      return updateUsers(state, [teamMember]);
    }
    case WASABI_SAAS_FETCH_USER_SUBSCRIPTIONS_SUCCESS: {
      const { users } = action;
      return updateUsers(state, users);
    }
    default: {
      return state;
    }
  }
}
